<div id="my-info" class="flex flex-col self-start flex-1 w-full gap-3 px-4 my-6 md:mb-0 md:py-0">
    <p class="hidden text-2xl font-bold text-gray-800 md:block">마이페이지</p>
    <div class="hidden border-b-2 border-gray-500 md:block"></div>
    <p class="hidden font-bold cursor-pointer md:block hover:text-primary" routerLinkActive="text-primary " routerLink="/my-page/profile">
        내 정보
    </p>
    <div class="block border-b-2 border-gray-500 md:hidden"></div>
    <div class="hidden w-full h-px bg-gray-200 md:block"></div>
    <p class="font-bold cursor-pointer hover:text-primary" routerLinkActive="text-primary " routerLink="/my-page/history">예약내역</p>
    <div class="w-full h-px bg-gray-200"></div>
    <p class="font-bold cursor-pointer hover:text-primary" routerLinkActive="text-primary " routerLink="/my-page/activity">내 활동</p>
    <div class="w-full h-px bg-gray-500"></div>
</div>

<div id="update-info" class="flex-col hidden gap-3 md:flex">
    <p class="hidden text-2xl font-bold text-gray-800 md:block">회원정보 수정</p>
    <div class="border-b-2 border-gray-500"></div>
    <p
        class="hidden font-bold cursor-pointer md:block hover:text-primary"
        routerLinkActive="text-primary "
        [routerLink]="['/my-page', 'profile', 'updateInfo']"
        [queryParams]="{ segment: 'profile' }"
    >
        내 정보 수정
    </p>
    <div class="hidden w-full h-px bg-gray-200 md:block"></div>
    <p
        class="font-bold cursor-pointer hover:text-primary"
        routerLinkActive="text-primary "
        [routerLink]="['/my-page', 'profile', 'updateInfo']"
        [queryParams]="{ segment: 'password' }"
    >
        비밀번호 변경
    </p>

    <div class="w-full h-px bg-gray-500"></div>
</div>
